import React from 'react'

const IconAdd = (props) => {
    return (
        <svg {...props} viewBox="0 0 20 20" fill="none" >
            <path d="M5 10H15M10 15V5" stroke="currentcolor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default IconAdd